"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.UNDERSHOOT_FACTOR = exports.SVG_SIZE = exports.SVG_RADIUS = exports.SVG_CIRCUMFERENCE = exports.SVG_CENTER = exports.SPINNER_ROTATION_DEGREES = exports.SPINNER_RADIUS = exports.SPINNER_KEYTIMES = exports.SPINNER_DASHOFFSET_FACTOR = exports.SPINNER_DASHARRAY_MIN = exports.SPINNER_DASHARRAY_MAX = exports.SPINNER_DASHARRAY_HALF = exports.SPACE_WITH_LABEL = exports.SPACE_WITHOUT_LABEL = exports.ROTATION_TRANSFORM = exports.OVERSHOOT_FACTOR = exports.DURATION = exports.DOT_FADEOUT_OUTPUT_RANGE = exports.DOT_FADEOUT_INPUT_RANGE = exports.DOTS_TOTAL_ANIMATION_DURATION = exports.DOTS_STYLE = exports.DOTS_SPACING_X = exports.DOTS_PADDING_FACTOR = exports.DOTS_JUMP_HEIGHT_FACTOR = exports.DOTS_FADEOUT_VALUES = exports.DOTS_FADEOUT_KEYTIMES = exports.DOTS_BASE_Y_FACTOR = exports.DOTS_ANIMATION_DURATION = exports.DOT3_COLOR_KEYTIMES = exports.DOT3_ANIMATION_KEYTIMES = exports.DOT3_ANIMATION_INPUT_RANGE = exports.DOT2_COLOR_KEYTIMES = exports.DOT2_ANIMATION_KEYTIMES = exports.DOT2_ANIMATION_INPUT_RANGE = exports.DOT1_COLOR_KEYTIMES = exports.DOT1_ANIMATION_KEYTIMES = exports.DOT1_ANIMATION_INPUT_RANGE = exports.BOUNCY_CURVE = exports.BACKDROP_Z_INDEX = exports.BACKDROP_OPACITY = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Spinner
const DURATION = exports.DURATION = 1200;
const SVG_RADIUS = exports.SVG_RADIUS = 20;
const SVG_CIRCUMFERENCE = exports.SVG_CIRCUMFERENCE = SVG_RADIUS * 2 * Math.PI;
const SVG_SIZE = exports.SVG_SIZE = 48;
const ROTATION_TRANSFORM = exports.ROTATION_TRANSFORM = 'rotate(-90 24 24)';
const SVG_CENTER = exports.SVG_CENTER = 24;
const SPINNER_RADIUS = exports.SPINNER_RADIUS = 20;
const SPINNER_ROTATION_DEGREES = exports.SPINNER_ROTATION_DEGREES = 183;
const SPINNER_DASHARRAY_MIN = exports.SPINNER_DASHARRAY_MIN = 0.01;
const SPINNER_DASHARRAY_MAX = exports.SPINNER_DASHARRAY_MAX = 0.99;

// Spinner animation
const SPINNER_KEYTIMES = exports.SPINNER_KEYTIMES = '0; 0.5; 1';
const SPINNER_DASHARRAY_HALF = exports.SPINNER_DASHARRAY_HALF = 0.5;
const SPINNER_DASHOFFSET_FACTOR = exports.SPINNER_DASHOFFSET_FACTOR = 0.49;

// Dots
const DOTS_ANIMATION_DURATION = exports.DOTS_ANIMATION_DURATION = 300;
const DOTS_TOTAL_ANIMATION_DURATION = exports.DOTS_TOTAL_ANIMATION_DURATION = DOTS_ANIMATION_DURATION * 10;
const OVERSHOOT_FACTOR = exports.OVERSHOOT_FACTOR = 1.3;
const UNDERSHOOT_FACTOR = exports.UNDERSHOOT_FACTOR = 0.2;
const BOUNCY_CURVE = exports.BOUNCY_CURVE = '0.2 1 0.8 1';
const DOTS_SPACING_X = exports.DOTS_SPACING_X = 3;
const DOTS_BASE_Y_FACTOR = exports.DOTS_BASE_Y_FACTOR = 3;
const DOTS_JUMP_HEIGHT_FACTOR = exports.DOTS_JUMP_HEIGHT_FACTOR = 1;
const DOTS_PADDING_FACTOR = exports.DOTS_PADDING_FACTOR = 0.5;

// Dots fadeout
const DOTS_FADEOUT_KEYTIMES = exports.DOTS_FADEOUT_KEYTIMES = '0; 0.7; 0.8; 1';
const DOTS_FADEOUT_VALUES = exports.DOTS_FADEOUT_VALUES = '1; 1; 0; 0';

// Dots animation
const DOT1_ANIMATION_KEYTIMES = exports.DOT1_ANIMATION_KEYTIMES = '0; 0.1; 0.2; 1';
const DOT2_ANIMATION_KEYTIMES = exports.DOT2_ANIMATION_KEYTIMES = '0; 0.3; 0.4; 0.5; 1';
const DOT3_ANIMATION_KEYTIMES = exports.DOT3_ANIMATION_KEYTIMES = '0; 0.6; 0.7; 0.8; 1';

// Dots color keytimes
const DOT1_COLOR_KEYTIMES = exports.DOT1_COLOR_KEYTIMES = '0; 0.3; 0.4; 1';
const DOT2_COLOR_KEYTIMES = exports.DOT2_COLOR_KEYTIMES = '0; 0.3; 0.4; 0.6; 0.7; 1';
const DOT3_COLOR_KEYTIMES = exports.DOT3_COLOR_KEYTIMES = '0; 0.5; 0.6; 0.8; 1';

// Dots native fadeout
const DOT_FADEOUT_INPUT_RANGE = exports.DOT_FADEOUT_INPUT_RANGE = [0, 0.7, 0.8, 1];
const DOT_FADEOUT_OUTPUT_RANGE = exports.DOT_FADEOUT_OUTPUT_RANGE = [1, 1, 0, 0];

// Dots native animation
const DOT1_ANIMATION_INPUT_RANGE = exports.DOT1_ANIMATION_INPUT_RANGE = [0, 0.1, 0.2, 1];
const DOT2_ANIMATION_INPUT_RANGE = exports.DOT2_ANIMATION_INPUT_RANGE = [0, 0.3, 0.4, 0.5, 1];
const DOT3_ANIMATION_INPUT_RANGE = exports.DOT3_ANIMATION_INPUT_RANGE = [0, 0.6, 0.7, 0.8, 1];

// Backdrop
const BACKDROP_OPACITY = exports.BACKDROP_OPACITY = 0.06;
const BACKDROP_Z_INDEX = exports.BACKDROP_Z_INDEX = 1400;

// Space
const SPACE_WITH_LABEL = exports.SPACE_WITH_LABEL = 3;
const SPACE_WITHOUT_LABEL = exports.SPACE_WITHOUT_LABEL = 0;

// Style
const DOTS_STYLE = exports.DOTS_STYLE = 'dots';
const propTypes = exports.propTypes = {
  color: _propTypes.default.string.isRequired,
  baseColor: _propTypes.default.string,
  label: _propTypes.default.string.isRequired,
  size: _propTypes.default.number.isRequired,
  dotsize: _propTypes.default.number,
  thickness: _propTypes.default.number.isRequired,
  isStatic: _propTypes.default.bool
};